module.exports = __webpack_public_path__ + "img/lactation_room.5b8b65b5.png";